import axios from "axios"

import ManagerToken from "../../classes/ManagerToken"
import { saveLogRequest } from "./log"

const URL_API_UAT = 'https://apiuat.opti.marketing'
const URL_API_PROD = 'https://api.opti.marketing'
const URL_API_LOCAL = 'https://localhost:44391'
const URL_API_DEV = 'https://apidev.opti.marketing'
const URL_API_DOCKER_UAT = 'https://apiuatdocker.opti.marketing'

const URL_FRONT_UAT = 'https://uat.opti.marketing'
const URL_FRONT_PROD = 'https://web.opti.marketing'
const URL_FRONT_LOCAL = 'https://localhost:8080'

export const URL_FRONT = URL_FRONT_PROD
export const URL = URL_API_PROD

export const api = axios.create({
    baseURL: URL,
})

api.interceptors.request.use(function (config) {
    const token = ManagerToken.accessToken
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
}, function (error) {
    return error
})

const managerError401 = async (erro) =>
    await ManagerToken.loginAPI(`${URL}/token`).then(() => api(erro.config))

api.interceptors.response.use(
    (response) => response,
    function (error) {
        saveLogRequest(error)
        if (error?.response?.status === 401) return managerError401(error)
        if (error.response) {
            /**
             * Se a resposta do servidor for recebida com um status de erro (por exemplo, 400, 500, etc.)
             */
            return Promise.reject(error.response.data)
        } else if (error.request) {
            /**
             * Se a requisição foi feita, mas não houve resposta do servidor
             */
            return Promise.reject(error)
        } else {
            /**
             * Se houver um erro antes de enviar a requisição (por exemplo, configuração inválida)
             */
            return Promise.reject(error)
        }
    }
)
